export default "__VITE_ASSET__DEGp1Jaz__"